import Drawer from '@mui/material/Drawer';
import Routes from 'config/routes-constant';
import { toggleDrawer, useLayoutDispatch, useLayoutState } from 'context/HamberProvider';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import DashboardIcon from '@mui/icons-material/Dashboard';
import MapIcon from '@mui/icons-material/Map';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import i18n from 'config/i18n';
import { useTranslation } from 'react-i18next';
import HeaderSidebar from './HeaderSidebar';

import * as S from './sidebar.styles';
import SidebarItem from './SidebarItems';

const MenuDrawer = () => {
  const LayoutDispatch = useLayoutDispatch();
  const { drawerOpen } = useLayoutState();

  const { t } = useTranslation();
  const navigate = useNavigate();
  const dir = i18n.dir();
  const links = useRef([
    {
      key: 'dashboard',
      url: Routes.dashboard,
      icon: <DashboardIcon />,
    },
    {
      key: 'profile',
      url: Routes.profile,
      icon: <AccountCircleOutlinedIcon />,
    },
    {
      key: 'viewMiles',
      url: Routes.viewMiles,
      icon: <MapIcon />,
    },
    {
      key: 'claimMiles',
      url: Routes.claimMiles,
      icon: <AirplanemodeActiveIcon />,
    },
    {
      key: 'calculation',
      url: Routes.calculation,
      icon: <CalculateOutlinedIcon />,
    },
    {
      key: 'tickets',
      url: Routes.tickets,
      icon: <QuestionAnswerIcon />,
    },
    // {
    //     name: 'Services',
    //     url: '/service',
    //     icon: <BusinessCenterOutlinedIcon />
    // },
    // {
    //     name: 'Support',
    //     url: '/support',
    //     icon: <SupportAgentOutlinedIcon />
    // },
  ]);

  return (
    <div>
      <Drawer
        open={drawerOpen}
        anchor={dir === 'rtl' ? 'right' : 'left'}
        onClose={() => {
          toggleDrawer(LayoutDispatch);
        }}
      >
        <S.Wrapper>
          <HeaderSidebar />
          <SidebarItem />
        </S.Wrapper>
      </Drawer>
    </div>
  );
};
export default MenuDrawer;
